import { render, staticRenderFns } from "./ci_resource_details_page.vue?vue&type=template&id=71c7a3ea"
import script from "./ci_resource_details_page.vue?vue&type=script&lang=js"
export * from "./ci_resource_details_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports